<script lang="ts">
  import { onMount } from 'svelte';
  export let blok: {countdownEnd: string, countdownDate: string, countdownTime: string};
  let days: number = 0;
  let hours: number = 0;
  let minutes: number = 0;
  let seconds: number = 0;
  const countdownEndDate = new Date(blok.countdownEnd);
  const calculateTimeLeft = () => {
    if (!blok.countdownEnd) return;
    const now = new Date();
    const difference = countdownEndDate.getTime() - now.getTime();



    if (difference > 0) {
      days = Math.floor(difference / (1000 * 60 * 60 * 24));
      hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      minutes = Math.floor((difference / (1000 * 60)) % 60);
      seconds = Math.floor((difference / 1000) % 60);
    } else {
      days = 0;
      hours = 0;
      minutes = 0;
      seconds = 0;
    }
  };

  onMount(() => {
    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  });
</script>

<style type="scss">
    .countdown {
        display: grid;
        gap: 10px;
        border-radius: 10px;
        border: 1px solid white;
        padding: 20px;
        color: white;
        margin: 0 auto;
        font-family: var(--font-secondary);
        max-width: 90%;
        background: rgba(0, 0, 0, 0.3);
    }

    .event-info {
        text-align: center;
        margin-bottom: 10px;
        font-size: 1.25rem;
        font-family: var(--font-primary);
        order: 1;
        grid-column: span 2;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .event-info .date,
    .event-info .time-zone {
        display: block;
        width: 100%;
        line-height: 2rem;
        font-size: 1.25rem;
        text-align: center;
        white-space: nowrap;
    }

    .time-grid {
        display: grid;
        gap: 20px;
        grid-template-columns: 1fr 1fr;
        justify-content: center;
        align-items: center;
        order: 2;
        grid-column: span 2;
    }

    .time-section {
        text-align: center;
    }

    .time {
        font-size: 3rem;
        font-weight: 600;
        line-height: 4rem;
    }

    .label {
        font-size: 0.75rem;
        font-weight: bold;
        text-transform: uppercase;
        margin-top: 5px;
        font-family: var(--font-primary);
    }

    /* Responsive styling */
    @media (min-width: 768px) {
        .countdown {
            grid-auto-flow: column;
            max-width: fit-content;
            align-items: center;
            gap: 20px;
            padding: 12px 20px 20px 20px;
        }

        .event-info {
            order: 5;
            grid-column: auto;
            margin-bottom: 0;
            text-align: left;
            justify-content: flex-start;
            align-items: flex-start;
            white-space: normal;
        }

        .event-info .date,
        .event-info .time-zone {
          text-align: left;
        }

        .time-grid {
            display: inline-flex;
            gap: 20px;
            order: 1;
            grid-column: span 2;
        }

        .time-section {
            margin: 0;
        }

        .time {
            font-size: 3rem;
        }
    }
</style>


<div class="countdown">
  <div class="event-info">
    <div class="date">{blok.countdownDate}</div>
    <div class="time-zone">{blok.countdownTime}</div>
  </div>
  <div class="time-grid">
    <div class="time-section">
      <div class="time">{days}</div>
      <div class="label">Days</div>
    </div>
    <div class="time-section">
      <div class="time">{hours}</div>
      <div class="label">Hours</div>
    </div>
    <div class="time-section">
      <div class="time">{minutes}</div>
      <div class="label">Minutes</div>
    </div>
    <div class="time-section">
      <div class="time">{seconds}</div>
      <div class="label">Seconds</div>
    </div>
  </div>
</div>
